import React, { Component } from "react";
import CommonModalView from "presentational/common/modals/CommonModalView";
import ClearAdornmentButtonView from "presentational/common/ClearAdornmentButtonView";
import CommonTextField from "presentational/common/CommonTextField";
import TXT from "presentational/common/multinational/TXT";
import config from "lib/fr-config";
import { getFilteredInput, removeDoubleSpace } from "lib/textFilter";
import PropTypes from "prop-types";

const MAX_LENGTH_OF_TAG = config.lengthOfHashtag;

class TagSelectorModalView extends Component {
  static propTypes = {
    value: PropTypes.string,
    open: PropTypes.bool.isRequired,
    multiTagMode: PropTypes.bool,
    onClose: PropTypes.func.isRequired,
    onSelect: PropTypes.func.isRequired
  };

  static defaultProps = {
    multiTagMode: false
  };

  state = {
    valueOfProps: null,
    tempValue: ""
  };

  syncValue() {
    const { value } = this.props;
    const { valueOfProps } = this.state;
    if (value !== valueOfProps) {
      this.setState({
        valueOfProps: value,
        tempValue: value
      });
    }
  }

  getHashText() {
    const text = this.getFilteredFullText();
    if (!text || text === "") {
      return null;
    } else {
      return (
        text &&
        text
          .split(" ")
          .map(word => `#${word}`)
          .join(" ")
      );
    }
  }

  getFilteredFullText() {
    const { multiTagMode } = this.props;
    const { tempValue } = this.state;

    if (!tempValue || tempValue === "") return null;

    let returnText;
    switch (multiTagMode) {
      case true:
        const filteredText = tempValue
          .split(" ")
          .map(word => getFilteredInput("tag", word))
          .join(" ");
        const textWithoutDoubleSpace = removeDoubleSpace(filteredText).trim();
        const deduplicatedText = this.getDeduplicateHash(
          textWithoutDoubleSpace
        );
        returnText = this.checkMaxLengthOfTag(deduplicatedText);
        break;
      case false:
        returnText = getFilteredInput("tag", tempValue);
        break;
      default:
        console.log("error");
        console.error("error");
        break;
    }

    return returnText;
  }

  getDeduplicateHash(input) {
    const inputArr = input.split(" ");
    const outputArr = inputArr.reduce(function (a, b) {
      if (a.indexOf(b) < 0) a.push(b);
      return a;
    }, []);
    return outputArr.join(" ");
  }

  checkMaxLengthOfTag(input) {
    const inputArr = input.split(" ");
    const outputArr = inputArr.filter((v, idx) => idx < MAX_LENGTH_OF_TAG);
    return outputArr.join(" ");
  }

  changeValue(value) {
    this.setState({ tempValue: value });
  }

  submitValue() {
    const { onClose, onSelect } = this.props;
    onSelect(this.getFilteredFullText());
    onClose();
  }

  handleKeyPress = e => {
    if (e.key === "Enter") {
      this.submitValue();
      e.preventDefault();
    }
  };

  handleChange = e => {
    const { value } = e.target;
    this.changeValue(value);
  };

  handleReset = () => {
    this.changeValue("");
    this.inputField.focus();
  };

  handleSubmitBtnClick = () => {
    this.submitValue();
  };

  render() {
    const { open, onClose } = this.props;
    const { tempValue } = this.state;

    return (
      <CommonModalView
        open={open}
        onClose={onClose}
        paperStyle={{ width: "100%" }}
        titleText={<TXT name="titleModal_hash" />}
        contentComponent={
          <CommonTextField
            inputRef={ref => (this.inputField = ref)}
            autoFocus
            value={tempValue || ""}
            onKeyDown={this.handleKeyPress}
            onChange={this.handleChange}
            margin="normal"
            helperText={this.getHashText()}
            InputProps={{
              endAdornment: (
                <ClearAdornmentButtonView onClick={this.handleReset} />
              )
            }}
          />
        }
        firstButtonText={<TXT name="btnModal_cancel" />}
        firstButtonFunc={onClose}
        secondButtonText={<TXT name="btnModal_ok" />}
        secondButtonFunc={this.handleSubmitBtnClick}
      />
    );
  }

  componentDidMount() {
    this.syncValue();
  }

  componentDidUpdate() {
    this.syncValue();
  }
}

export default TagSelectorModalView;
